import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import moment from 'moment';
import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import { FHETable, LogChipType, LogChipCategory, LogChipProductType } from 'data/components';
import selectors from '../selectors';
import tools from "../../../../../data/common/tools";

class TableHomeProducts extends PureComponent {
    static propTypes = {
        events: PropTypes.array.isRequired,
        loading: PropTypes.bool.isRequired
    };

    renderData = memoizeOne(events => {
        let result = [];

        events.forEach(event => {
            result.push({
                category: event.category,
                type: event.type,
                username: event.username,
                date: moment.unix(event.timestamp).format('DD/MM/YYYY HH:MM:ss'),
                message: event.message
            });
        });
        return result;
    });

    renderColumns = memoizeOne(() => {
        return [
            {
                title: Translator.translate('general.table.column.category'),
                name: 'category',
                render: (row, data, value) => {
                    let res = null;
                    switch (value) {
                        case 'Box':
                            res = <LogChipCategory category="box" />;
                            break;
                        case 'History':
                            res = <LogChipCategory category="history" />;
                            break;
                        case 'Notifications':
                            res = <LogChipCategory category="notifications" />;
                            break;
                        case 'Ticket':
                            res = <LogChipCategory category="ticket" />;
                            break;
                        case 'Device':
                            res = <LogChipCategory category="device" />;
                            break;
                        case 'Settings':
                            res = <LogChipCategory category="settings" />;
                            break;
                        case 'Planning':
                            res = <LogChipCategory category="planning" />;
                            break;
                        case 'Account':
                            res = <LogChipCategory category="account" />;
                            break;
                        case 'User':
                            res = <LogChipCategory category="user" />;
                            break;
                        case 'Dashboard':
                            res = <LogChipCategory category="dashboard" />;
                            break;
                        case 'Journalisation':
                            res = <LogChipCategory category="journalisation" />;
                            break;
                        case 'Mail':
                            res = <LogChipCategory category="mail" />;
                            break;
                        case 'Cgu':
                            res = <LogChipCategory category="cgu" />;
                            break;
                        case 'SensorPilot':
                            res = <LogChipProductType productType="sensor" />;
                            break;
                    }
                    return res;
                }
            },
            {
                title: Translator.translate('general.table.column.type'),
                name: 'type',
                render: (row, data, value) => {
                    let res = null;
                    switch (value) {
                        case 'update':
                            res = <LogChipType type="modification" />;
                            break;
                        case 'info':
                            res = <LogChipType type="information" />;
                            break;
                        case 'delete':
                            res = <LogChipType type="suppression" />;
                            break;
                        case 'create':
                            res = <LogChipType type="creation" />;
                            break;
                        case 'support':
                            res = <LogChipCategory category="user" />;
                            break;
                    }
                    return res;
                }
            },
            {
                title: Translator.translate('general.table.column.username'),
                name: 'username'
            },
            {
                title: Translator.translate('general.table.column.date'),
                name: 'date',
                customSort: tools.sortDate,
                defaultSort: 'desc'
            },
            {
                title: Translator.translate('general.table.column.message'),
                name: 'message'
            }
        ];
    });

    render() {
        const { events, loading } = this.props;

        return (
            <FHETable
                idTable="homeDetailJournalisation"
                isLoading={loading}
                columns={this.renderColumns()}
                data={this.renderData(events)}
                minified
                emptyDataSourceMessage={Translator.translate('generic.home.journalisation.table.body.emptyDataSourceMessage')}
            />
        );
    }
}
function mapStateToProps(state) {
    return {
        profile: selectors.getProfile(state)
    };
}

const styles = () => ({
    loadingContainer: {
        textAlign: 'center',
        margin: 20
    }
});

export default withRouter(connect(mapStateToProps)(withStyles(styles, { withTheme: true })(TableHomeProducts)));



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Home/tables/TableHomeJournalisation.js